// @flow
import React from 'react';
import { bind } from '@ta/common.api';
import QuickLinkTiles from '@ta/brand.quick-links';
import { TrackingNamespaceContext, HomeTrackingContext } from '@ta/tracking.interactions';
import styles from './QuickLinkTilesContainer.css';

type Props = {
  uid: string,
  scopedGeoId: number,
};

/**
 * A wrapper component that renders the quicklinks and/or single search below the hero photo
 */
const QuickLinkTilesContainer = ({ uid, scopedGeoId }: Props) => (
  <div className={styles.container}>
    <TrackingNamespaceContext.Provider value="home">
      <HomeTrackingContext.Provider value={{ uid, scopedGeoId }}>
        <QuickLinkTiles color="black" />
      </HomeTrackingContext.Provider>
    </TrackingNamespaceContext.Provider>
  </div>
);

export default bind<Props, {||}, _, _, _, _>((state, stage) => {
  const scopedGeoId = +state.route.geo || 1;

  QuickLinkTiles.stage(state, stage);

  return () => ({
    uid: state.tracking.uid || '',
    scopedGeoId,
  });
})(QuickLinkTilesContainer);
